export const POLICY_ISSUANCE_POLL_INTERVAL = 5_000;
export const POLICY_ISSUANCE_POLL_TIMEOUT_DURATION = 150_000;
